import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export const CARD_APPEARANCES = ['outlined', 'shadowed', 'default', 'contents', 'layout'] as const;
export const CARD_PADDING = ['default', 'cosy', 'tight', 'none'] as const;
export type CardAppearance = (typeof CARD_APPEARANCES)[number];
export type CardPadding = (typeof CARD_PADDING)[number];

@Component({
  selector: 'forma-card',
  templateUrl: './card.html',
  styleUrls: ['./card.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClasses()',
  },
})
export class Card {
  appearance = input<CardAppearance>('default');
  padding = input<CardPadding>('default');
  protected hostClasses = computed(() => {
    const classes: Record<string, boolean> = {};

    for (const appearanceOption of CARD_APPEARANCES) {
      classes[`forma-card--${appearanceOption}`] = this.appearance() === appearanceOption;
    }
    for (const paddingOption of CARD_PADDING) {
      classes[`forma-card--padding-${paddingOption}`] = this.padding() === paddingOption;
    }
    return classes;
  });
}
